import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AddAffectationComponent } from "./add-affectation/add-affectation.component";
import { EditAffectationComponent } from "./edit-affectation/edit-affectation.component";
import { TaskWorkflowByProfile } from "../core/model/task-workflow-by-profile";
import { TaskWorkflowByProfileService } from "../core/service/task-workflow-by-profile.service";
import { Affectation } from "../core/model/affectation";
import { AffectationService } from "../core/service/affectation.service";

@Component({
  selector: "app-affectation",
  templateUrl: "./affectation.component.html",
  styleUrls: ["./affectation.component.scss"],
})
export class AffectationComponent implements OnInit {
  taskId: number;
  task: TaskWorkflowByProfile;

  affectations: Affectation[];

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _affectationService: AffectationService,
    private _taskWorkflowByProfileService: TaskWorkflowByProfileService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this._activatedRoute.params.subscribe((params: Params) => {
      this.taskId = params["taskId"];
      this.getAffectationsByTaskId(this.taskId);
      this.getTask(this.taskId);
    });
  }

  getAffectationsByTaskId(taskid) {
    this._affectationService.getAffectationsByTaskId(taskid).subscribe(
      (data) => {
        this.affectations = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getTask(taskId) {
    this._taskWorkflowByProfileService
      .getTaskWorkflowByProfileById(taskId)
      .subscribe(
        (data) => {
          this.task = data;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  edit(affectation: Affectation): void {
    const modalRef = this.modalService.open(EditAffectationComponent, {
      centered: true,
    });
    modalRef.componentInstance.affectation = affectation;

    modalRef.result.then(
      (updated: Affectation) => {
        if (updated && this.affectations) {
          const index = this.affectations.findIndex(
            (a) => a.id === updated.id
          );
          if (index !== -1) {
            this.affectations[index] = updated;
            this.affectations = [...this.affectations];
            return;
          }
        }
        this.getAffectationsByTaskId(this.taskId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  add(): void {
    const modalRef = this.modalService.open(AddAffectationComponent, {
      centered: true,
    });
    // Contexte filtre (pas l'entité éditée)
    modalRef.componentInstance.taskId = this.taskId;

    modalRef.result.then(
      (data) => {
        // on close
        this.getAffectationsByTaskId(this.taskId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  delete(ferieId) {
    this._affectationService.delete(ferieId).subscribe(
      (data) => {
        this.getAffectationsByTaskId(this.taskId);
      },
      (error) => {
        console.log(error);
      }
    );
  }
}
